import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { useTimeModal } from '../TimeModal/TimeModalContext';

import AttachAM from './Modals/AttachAM';
import ListMailing from './Modals/ListMailing';
import ConfirmAppointment from './Modals/ConfirmAppointment';

import Loading from '../Loading';
import WarningPanel from '../WarningPanel';
import Modal from '../Modal';

import IconContainer from '../IconContainer';
import { ReactComponent as ShieldCheckIcon } from '../../icons/shield-check-n.svg';
import { ReactComponent as ShieldWarningIcon } from '../../icons/shield-warning.svg';

const AMPanel = ({ id, number, caseInfo, reload, setReload, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [isAttachAM, setIsAttachAM] = React.useState(false);
    const [isListMailing, setIsListMailing] = React.useState(false);
    const [AMPanelInfo, setAMPanelInfo] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        setLoading(true);

        axios.get(`/api/get-info-for-am-panel?case_id=${id}`, {
            headers: { Authorization: `Bearer ${token}` }
        })
        .then((response) => {
            setAMPanelInfo(response.data);
        })
        .catch((error) => {
            console.error('Ошибка при получении данных am panel:', error);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        });
    }, [reload, id]);

    React.useEffect(() => {
        if (AMPanelInfo.mailing_status=='Производится рассылка') {
            setTimeout(() => setReload(true), 10000);
        };
    }, [AMPanelInfo]);

    const removeAMFromCase = () => {
        const token = localStorage.getItem('token');

        setLoading(true);

        axios.put(`/api/remove-AM-from-case?caseId=${id}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then(() => {
            openTimeModal('Арбитражный управляющий откреплен', 'success');
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`Не удалось открепить арбитражного управляющего  ${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            onSuccess();
            setReload(true);
            setLoading(false);
        })
    };

    const [confirming, setConfirming] = React.useState(false);
    const handleClick = () => {
        if (confirming) {
            removeAMFromCase();
        } else {
            setConfirming(true);
        }
    };
    React.useEffect(() => {
        let timer;
        if (confirming) {
            timer = setTimeout(() => setConfirming(false), 3000);
        }
        return () => clearTimeout(timer);
    }, [confirming]);

    const openAttachAM = () => {
        setIsAttachAM(true);
        setIsListMailing(false);
    };

    React.useEffect(() => {
        if (window.location.hash === '#attach-am') {
            setIsAttachAM(true);
        } else if (window.location.hash === '#list-mailing') {
            setIsListMailing(true);
        }
    }, []);

    const [isModalConfirmAppointment, setIsModalConfirmAppointment] = React.useState(false);
    const [currentAction, setCurrentAction] = React.useState('');

    const openSuperModal = (action, window) => {
        setCurrentAction(action);
        if (window=='AttachAM') setIsAttachAM(true);
        if (window=='ListMailing') setIsListMailing(true);
        if (window=='ConfirmAppointment') setIsModalConfirmAppointment(true);
    };

    return (
        <>
            <Modal isOpen={isAttachAM} closeModal={() => {setIsAttachAM(false); window.location.hash = ''}}>
                <AttachAM 
                    caseId={id} 
                    caseNumber={number} 
                    closeModal={() => {setIsAttachAM(false)}} 
                    onSuccess={() => {
                        onSuccess(); 
                        setReload(true);
                    }} 
                />
            </Modal>
            <Modal isOpen={isListMailing} closeModal={() => {setIsListMailing(false); window.location.hash = ''}}>
                <ListMailing 
                    caseId={id} 
                    closeModal={() => setIsListMailing(false)} 
                    openAttachAM={() => openAttachAM()} 
                    onSuccess={() => {
                        onSuccess(); 
                        setReload(true);
                    }} 
                />
            </Modal>
            <Modal isOpen={isModalConfirmAppointment} closeModal={() => {setIsModalConfirmAppointment(false); window.location.hash = ''}}>
                <ConfirmAppointment 
                    caseId={id} 
                    caseInfo={caseInfo} 
                    AM={AMPanelInfo.user}
                    action={currentAction}
                    closeModal={() => {setIsModalConfirmAppointment(false)}} 
                    onSuccess={() => {
                        onSuccess(); 
                        setReload(true);
                    }} 
                />
            </Modal>

            <div className='panel'>
            {loading ? (
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}><Loading /></div>
            ) : (
            <>    
                {AMPanelInfo.user_id ? 
                    AMPanelInfo.user == null ? 
                    <WarningPanel text='Произошла ошибка: учётная запись арбитражного управляющего не найдена в системе. Возможно, она была удалена по запросу' type='error' />
                    :
                        <>
                            <div 
                                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}
                            >
                                <Link
                                    className='aWithLink'
                                    to={`/account/${AMPanelInfo.user_id}`}
                                >
                                    {AMPanelInfo.user?.lastname} {AMPanelInfo.user?.firstname} {AMPanelInfo.user?.surname}
                                </Link>
                                <span
                                    className='horizontalContainer'
                                >
                                    <p className='description'>
                                        {!AMPanelInfo.date_am_appointment_m ? "Выбран СРО" : "Утвержден Арбитражным судом"}
                                    </p>
                                    {caseInfo.status_am_appointment_approval &&
                                    <IconContainer 
                                        Icon={caseInfo.status_am_appointment_approval=='Подтверждено' ? ShieldCheckIcon : ShieldWarningIcon} 
                                        label={'Информация по подтверждению'}
                                        onClick={() => {openSuperModal('view', 'ConfirmAppointment')}} 
                                        size = '17' 
                                        color = {caseInfo.status_am_appointment_approval=='Подтверждено' ? 'green' : 'red'}  
                                        className = '' 
                                    />}
                                </span>
                            </div>
                            <a 
                                className='aWithLink'
                                href={`mailto:${AMPanelInfo.user?.email}`}
                            >
                                {AMPanelInfo.user?.email}
                            </a>
                            <span style={{height: '10px'}}></span>
                            <span
                                className='horizontalContainer'
                                style={{alignItems: 'normal'}}
                            >
                                {AMPanelInfo.mailing_status == "Письма отправлены" &&
                                <button 
                                    type='button' 
                                    className='miniButton' 
                                    onClick={() => {
                                        openSuperModal('', 'ListMailing'); 
                                        window.location.hash = 'list-mailing';
                                    }}
                                >
                                    Просмотреть информацию по рассылке
                                </button>}
                                {(AMPanelInfo.user_id && !caseInfo.status_am_appointment_approval) &&
                                <button 
                                    type='button' 
                                    className='miniButton' 
                                    onClick={() => {
                                        openSuperModal('confirm', 'ConfirmAppointment'); 
                                    }}
                                >
                                    Подтвердить назначение
                                </button>}
                                {!caseInfo.status_am_appointment_approval &&
                                <button 
                                    type='button' 
                                    className='miniButton' 
                                    onClick={handleClick}
                                >
                                    {confirming
                                    ? 'Вы уверены, что хотите открепить?'
                                    : 'Открепить арбитражного управляющего'}
                                </button>}
                            </span>
                        </> 
                : AMPanelInfo.mailing_status === "Письма не отправлены" ?
                <>
                    <a>Рассылка не проводилась</a>
                    <button type='button' className='button miniButton' onClick={() => {setIsAttachAM(true); window.location.hash = 'attach-am';}}>Перейти к рассылке</button>
                </>
                : AMPanelInfo.mailing_status === "Письма отправлены" ?
                <>
                    <a>Рассылка совершена</a>
                    <button type='button' className='button miniButton' onClick={() => {setIsListMailing(true); window.location.hash = 'list-mailing';}}>Просмотреть всю информацию</button>
                </>
                : AMPanelInfo.mailing_status === "Производится рассылка" ?
                <>
                    <a style={{display: 'flex', alignItems: 'center', gap: '10px'}}>Производится автоматическая рассылка <Loading type='inline'/></a>
                    <p className='description'>Вы можете выйти со страницы, на процесс рассылки это не повлияет</p>
                </>
                : <p className='description'>Не удалось загрузить компонент. Попробуйте обновить страницу</p>}
            </>)}
            </div>
        </>
    )
}

export default AMPanel;